usuario.component('usuario.modalDadosComponent', {
    templateUrl: 'usuario/modalDados/modalDados.html',
    controller: 'usuario.modalDadosController',
    controllerAs: '$modal',
    bindings: { usuario: '<', modal: '=' }
});

usuario.controller('usuario.modalDadosController', ['$scope', 'coreLanguage', 'coreFb', 'coreUtils', function($scope, $text, $fb, $utils){
    const $ctrl = this;
    $scope.$text = $text;

    const _getDominio=()=>{

        $ctrl.ddiOptions = [];
        $fb.db.get('sys_dominio/ddi').then(doc=>{
            $ctrl.ddiOptions = doc.data.values;
        });

        $ctrl.estadoOptions = [];
        $fb.db.get('sys_dominio/estados').then(doc => {
            $ctrl.estadoOptions = doc.data.values;
        });

    };

    $ctrl.onCepChange = () => {

        console.log($ctrl.endereco);

        if (!$ctrl.endereco || !$ctrl.endereco.cep || $ctrl.endereco.cep.length < 8) {
            return
        }

        $ctrl.cepState ={
            isLoading: true,
            hasError: false
        };

        $utils.httpReq('get', `https://viacep.com.br/ws/${$ctrl.endereco.cep}/json`).then(res => {
            if (res?.data.erro) {
                $ctrl.cepState.hasError = true;
                return
            };

            const enderecoData = {
                'logradouro': res.data.logradouro,
                'bairro': res.data.bairro,
                'complemento': res.data.complemento,
                'cidade': res.data.localidade,
                'uf': res.data.uf
            }

            Object.assign($ctrl.endereco, enderecoData);

        }).finally(() => {
            $ctrl.cepState.isLoading = false;
        });
    };

    $ctrl.submit=()=>{
        let dados = {};
        $ctrl.invalid = {};

        if($ctrl.modal.loading){
            return;
        }

        $ctrl.modal.loading = true;

        if($ctrl.modal.tipo === 'email'){
            if(!$ctrl.email){
                $ctrl.invalid.email = true;
                $ctrl.modal.loading = false;
                return;
            };

            dados = {email: $ctrl.email};

        }else if($ctrl.modal.tipo === 'telefone'){

            if(!$ctrl.telefone || (!$ctrl.telefone.ddi || !$ctrl.telefone.numero )){
                $ctrl.invalid.telefone = true;
                $ctrl.modal.loading = false;
                return;
            };

            dados = {telefone: $ctrl.telefone};

        }else if($ctrl.modal.tipo === 'endereco'){

            if(!$ctrl.endereco || (!$ctrl.endereco.cep || !$ctrl.endereco.numero )){
                
                if(!$ctrl.endereco.cep){
                    $ctrl.cepState = { hasError: true};
                }
                
                $ctrl.invalid.endereco = true;
                $ctrl.modal.loading = false;
                return;
            };

            dados = {endereco: $ctrl.endereco};

        }else{
            $ctrl.modal.loading = false;
            return;
        }

        $ctrl.modal.confirm(dados);
    };

    $ctrl.$onInit = () => {
        $ctrl[$ctrl.modal.tipo] = angular.copy($ctrl.usuario.data[$ctrl.modal.tipo]) || {};
        
        _getDominio();
    };

}]);